export const EXLY_COMMUNITY__BRANDED_COMMUNITY__SET_BONUS_OFFERINGS =
  "@EXLY_COMMUNITY/BRANDED_COMMUNITY/SET_BONUS_OFFERINGS";
export const EXLY_COMMUNITY__BRANDED_COMMUNITY__SET_COMMUNITY_DATA =
  "@EXLY_COMMUNITY/BRANDED_COMMUNITY/SET_COMMUNITY_DATA";
export const EXLY_COMMUNITY__BRANDED_COMMUNITY__FETCH_BONUS_OFFERINGS =
  "@EXLY_COMMUNITY/BRANDED_COMMUNITY/FETCH_BONUS_OFFERINGS";
export const EXLY_COMMUNITY__BRANDED_COMMUNITY__SET_ONBOARDING =
  "@EXLY_COMMUNITY/BRANDED_COMMUNITY/SET_ONBOARDING";
